/* -------------------------------------------------------------------
INIT - AOS LIBRARY
------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  if (!window.AOS) return;
  AOS.init({
    duration: 700,
    easing: 'ease-out',
    once: false,
    offset: 0
  });
});

// Re-scan quand l’éditeur charge/ajoute une section
document.addEventListener('shopify:section:load', function(){
  if (window.AOS) AOS.refreshHard();
});

/* -------------------------------------------------------------------
FUNCTIONS - LIQUID GLASS
------------------------------------------------------------------- */
// INIT SECTIONS LIQUID GLASS
(function () {
  function addGlassToSection(section) {
    const wrapper =
      section.querySelector('.color-background-1, .color-background-2, .color-background-3, .gradient, .section, .content-container, .page-width') ||
      section.firstElementChild ||
      section;
    wrapper.classList.add('yl-glass');
    wrapper.dataset.ylGlass = '1'; // marqueur pour un nettoyage ciblé
  }

  function applyGlassOnce() {
    if (!document.body.classList.contains('is-home')) return;

    // Nettoyage ciblé (évite de parcourir toutes les sections)
    document.querySelectorAll('[data-yl-glass="1"]').forEach(el => {
      el.classList.remove('yl-glass');
      el.removeAttribute('data-yl-glass');
    });

    const heros = document.querySelectorAll('section.yl-hero');
    if (!heros.length) return;

    heros.forEach(hero => {
      const heroSection = hero.closest('.shopify-section');
      if (!heroSection) return;

      let next = heroSection.nextElementSibling;
      while (next && !next.classList.contains('shopify-section')) {
        next = next.nextElementSibling;
      }
      if (next && !next.classList.contains('section-header')) {
        //addGlassToSection(next);
      }
    });
  }

  // DOM prêt
  const run = () => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(applyGlassOnce, { timeout: 200 });
    } else {
      setTimeout(applyGlassOnce, 0);
    }
  };

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:unload', run);
  document.addEventListener('shopify:section:reorder', run);
})();

// SCROLL SUR SECTIONS LIQUID GLASS
(function(){
  const els = Array.from(document.querySelectorAll('.yl-glass'));
  if (!els.length) return;

  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    // Option: figer à l'état “milieu”
    els.forEach(el => el.style.setProperty('--t', '0.5'));
    return;
  }

  let ticking = false;

  function update() {
    ticking = false;
    const vh = window.innerHeight || document.documentElement.clientHeight;

    els.forEach(el => {
      const rect = el.getBoundingClientRect();
      // zone d'animation : l'élément entre progressivement quand son top atteint 80% du viewport
      const start = vh * 0.8;
      const end = -rect.height * 0.2; // finit un peu après le centre
      const raw = (start - rect.top) / (start - end);
      const t = Math.max(0, Math.min(1, raw)); // clamp 0..1
      el.style.setProperty('--t', t.toFixed(4));
    });
  }

  function onScrollOrResize(){
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  // init + listeners
  onScrollOrResize();
  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);
})();

/* -------------------------------------------------------------------
SECTION BACKGROUND VIDEO
------------------------------------------------------------------- */
// Switch .yl-hero__media position from fixed to sticky after 2000px scroll
document.addEventListener('DOMContentLoaded', () => {
	const mediaEl = document.querySelector('.yl-hero__media');
	if (!mediaEl) return;

	const threshold = 2000; // scroll distance in px
	let isSticky = false;

	window.addEventListener('scroll', () => {
		const scrollY = window.scrollY || window.pageYOffset;
		const shouldBeSticky = scrollY >= threshold;

		// Avoid unnecessary reflows
		if (shouldBeSticky !== isSticky) {
			isSticky = shouldBeSticky;
			mediaEl.style.position = isSticky ? 'sticky' : 'fixed';
			mediaEl.style.top = isSticky ? '0' : '0';
		}
	});
});

/* -------------------------------------------------------------------
FUNCTIONS - YOBE ANIMATED STARS EFFECT
------------------------------------------------------------------- */
// Animated starfield overlay for multiple sections (newsletter + banner)
document.addEventListener('DOMContentLoaded', () => {
	// Select target sections
	const sectionEls = document.querySelectorAll('#shopify-section-newsletter');
	if(!sectionEls.length) return;

	// Keep references for global resize
	const instances = [];

	// Config (tune to taste)
	const starDensity = 0.08;
	const minRadius = 0.6;
	const maxRadius = 1.6;
	const maxSpeed = 0.5; // speed
	const twinkleSpeedMin = 0.002;
	const twinkleSpeedMax = 0.01;
	const dpr = Math.max(1, window.devicePixelRatio || 1);

	// Initialize an instance per section
	sectionEls.forEach(sectionEl => {
		// Avoid duplicates if already initialized
		if(sectionEl.querySelector('.yl-starsCanvas')) return;

		// Create and attach canvas
		const canvasEl = document.createElement('canvas');
		canvasEl.className = 'yl-starsCanvas';
		sectionEl.appendChild(canvasEl);

		const ctx = canvasEl.getContext('2d');
		const stars = [];
		let width = 0, height = 0;
		let isRunning = true;

		// Random helper
		const rand = (min, max) => min + Math.random() * (max - min);

		// Create a single star
		const makeStar = () => {
			const radius = rand(minRadius, maxRadius);
			const baseAlpha = rand(0.55, 0.95);
			const phase = rand(0, Math.PI * 2);
			return {
				x: Math.random() * width,
				y: Math.random() * height,
				radius,
				dx: rand(-maxSpeed, maxSpeed),
				dy: rand(-maxSpeed, maxSpeed),
				alpha: baseAlpha,
				baseAlpha,
				alphaSpeed: rand(twinkleSpeedMin, twinkleSpeedMax),
				phase
			};
		};

		// Create stars based on current size
		const reseedStars = () => {
			const targetCount = Math.round((width * height) * starDensity / 1000);
			stars.length = 0;
			for(let i = 0; i < targetCount; i++){
				stars.push(makeStar());
			}
		};

		// Resize canvas to match section size
		const resizeCanvas = () => {
			const rect = sectionEl.getBoundingClientRect();
			width = Math.max(1, Math.round(rect.width));
			height = Math.max(1, Math.round(rect.height));
			canvasEl.width = Math.round(width * dpr);
			canvasEl.height = Math.round(height * dpr);
			canvasEl.style.width = width + 'px';
			canvasEl.style.height = height + 'px';
			ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
			reseedStars();
		};

		// Draw loop (slow, subtle)
		const draw = () => {
			if(!isRunning) return;
			ctx.clearRect(0, 0, width, height);

			for(let i = 0; i < stars.length; i++){
				const s = stars[i];

				// Update position with gentle drift
				s.x += s.dx;
				s.y += s.dy;

				// Wrap around edges
				if(s.x < -2) s.x = width + 2;
				if(s.x > width + 2) s.x = -2;
				if(s.y < -2) s.y = height + 2;
				if(s.y > height + 2) s.y = -2;

				// Twinkle (slow opacity oscillation)
				s.phase += s.alphaSpeed;
				s.alpha = s.baseAlpha * (0.75 + 0.25 * Math.sin(s.phase));

				// Draw star (soft dot)
				const grd = ctx.createRadialGradient(s.x, s.y, 0, s.x, s.y, s.radius * 3);
				grd.addColorStop(0, `rgba(255,255,255,${s.alpha})`);
				grd.addColorStop(1, 'rgba(255,255,255,0)');
				ctx.fillStyle = grd;
				ctx.beginPath();
				ctx.arc(s.x, s.y, s.radius * 3, 0, Math.PI * 2);
				ctx.fill();
			}

			requestAnimationFrame(draw);
		};

		// Start / Stop using IntersectionObserver for perf
		const io = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				isRunning = entry.isIntersecting;
				if(isRunning) requestAnimationFrame(draw);
			});
		}, { threshold: 0.01 });
		io.observe(sectionEl);

		// Public resize for this instance
		const handleResize = () => resizeCanvas();

		// Init this instance
		resizeCanvas();
		requestAnimationFrame(draw);

		// Save instance handlers
		instances.push({ handleResize });
	});

	// Global resize: trigger each instance
	window.addEventListener('resize', () => {
		for(let i = 0; i < instances.length; i++){
			instances[i].handleResize();
		}
	});
});

/* -------------------------------------------------------------------
SCROLL TOP BUTTON
------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
	const scrollTopBtn = document.getElementById('scrollTopBtn');

	// Show button after scrolling down 300px
	window.addEventListener('scroll', () => {
		if (window.scrollY > 300) {
			scrollTopBtn.classList.add('show');
		} else {
			scrollTopBtn.classList.remove('show');
		}
	});

	// Smooth scroll to top on click
	scrollTopBtn.addEventListener('click', () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	});
});

/* -------------------------------------------------------------------
FUNCTIONS - HEADER
------------------------------------------------------------------- */
(function() {
  function armHeaderAnim() {
    document.documentElement.classList.add('is-loaded');
  }

  // Au premier chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armHeaderAnim, { once: true });
  } else {
    armHeaderAnim();
  }

  // Gestion Safari bfcache (retour arrière)
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) armHeaderAnim();
  });
})();

/* -------------------------------------------------------------------
FUNCTIONS - POLICIES PAGES
------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
	// Only on policy pages
	if (!document.body.classList.contains('is-policies')) return;

	const policyContainer = document.querySelector('.shopify-policy__container');
	if (!policyContainer) return;

	// Add liquid glass class
	policyContainer.classList.add('yl-glass');
	policyContainer.dataset.ylGlass = '1';
});

/* -------------------------------------------------------------------
FUNCTIONS - REGISTRATION
------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
	// Get register form by ID
	const registerForm = document.getElementById('create_customer'); // get register form
	if (!registerForm) return;

	// Get SIRET field elements
	const siretInput = registerForm.querySelector('#RegisterForm-siret'); // get SIRET input
	const siretStatus = registerForm.querySelector('#RegisterForm-siret-status'); // get status element (for loader / extra state)
	const siretError = registerForm.querySelector('#RegisterForm-siret-error'); // get error container
	const errorText = siretError ? siretError.querySelector('.form__message__text') : null; // get error text span
	const siretSuccess = registerForm.querySelector('#RegisterForm-siret-success'); // get success container
	const successText = siretSuccess ? siretSuccess.querySelector('.form__message__text') : null; // get success text span
	const submitButton = registerForm.querySelector('button[type="submit"], [type="submit"]'); // get submit button
	const siretFieldWrapper = document.getElementById('siret-field-wrapper'); // get .field wrapper

	// Get company and hidden customer type input
	const companyInput = registerForm.querySelector('#RegisterForm-company'); // get company input
	const customerTypeInput = registerForm.querySelector('#RegisterForm-customerType'); // get hidden customer type input

	if (
		!siretInput ||
		!siretStatus ||
		!siretError ||
		!errorText ||
		!siretSuccess ||
		!successText ||
		!submitButton ||
		!siretFieldWrapper ||
		!companyInput ||
		!customerTypeInput
	) {
		return;
	}

	let siretCheckTimeout = null;
	let siretIsValid = false;
	let siretChecking = false;

	// Lock submit button
	const lockSubmit = () => {
		submitButton.disabled = true;
		submitButton.classList.add('button--disabled');
	};

	// Unlock submit button
	const unlockSubmit = () => {
		submitButton.disabled = false;
		submitButton.classList.remove('button--disabled');
	};

	// Decide if submit must be locked or not according to current state
	const updateSubmitLock = () => {
		const hasCompany = companyInput.value.trim().length > 0;
		const hasSiretValue = siretInput.value.trim().length > 0;

		// If an API check is in progress, keep the button locked
		if (siretChecking) {
			lockSubmit();
			return;
		}

		// If user is trying to register as pro (company or SIRET filled),
		// we require a valid SIRET
		if (hasCompany || hasSiretValue) {
			if (!siretIsValid) {
				lockSubmit();
				return;
			}
		}

		// Otherwise, submit is allowed
		unlockSubmit();
	};

	// Reset UI state for SIRET field
	const resetSiretUi = () => {
		siretFieldWrapper.classList.remove('field--error', 'field--valid');
		siretStatus.textContent = '';
		siretStatus.classList.remove('siret-status--valid', 'siret-status--invalid');

		siretError.style.display = 'none';
		errorText.textContent = '';

		siretSuccess.style.display = 'none';
		successText.textContent = '';
	};

	// Show error message when SIRET is invalid
	const showSiretError = () => {
		resetSiretUi();
		siretFieldWrapper.classList.add('field--error');
		errorText.innerHTML = 'Votre numéro de SIRET ne semble pas valide.<br /><a href="/pages/contact">Contactez-nous</a> si besoin.'; // set error text
		siretError.style.display = 'flex'; // show error with icon
		siretStatus.classList.add('siret-status--invalid');
		siretIsValid = false;
		siretChecking = false;
		updateSubmitLock();
	};

	// Show success message when SIRET is valid
	const showSiretValid = () => {
		resetSiretUi();
		siretFieldWrapper.classList.add('field--valid');
		successText.textContent = 'Votre SIRET est valide'; // set success text
		siretSuccess.style.display = 'flex'; // show success with icon-checkmark
		siretStatus.classList.add('siret-status--valid');
		siretIsValid = true;
		siretChecking = false;
		updateSubmitLock();
	};

	// Set customer note according to company and SIRET fields
	const setCustomerTypeNote = () => {
		if (!companyInput || !siretInput || !customerTypeInput) {
			return;
		}

		const hasCompany = companyInput.value.trim().length > 0;

		// Pro only if company is filled and SIRET is valid
		if (siretIsValid) {
			// Pro customer
			customerTypeInput.value = 'Client professionnel';
		} else {
			// Individual customer
			customerTypeInput.value = 'Client particulier';
		}
	};

	// Call public API to check if SIRET exists
	const checkSiretWithApi = siretValue => {
		if (siretCheckTimeout) {
			// Clear any previous debounce call
			clearTimeout(siretCheckTimeout);
		}

		// Debounce to avoid calling API on every keystroke
		siretCheckTimeout = setTimeout(() => {
			siretChecking = true;
			lockSubmit();
			resetSiretUi();
			siretStatus.textContent = '...'; // show basic loading feedback

			const apiUrl = `https://recherche-entreprises.api.gouv.fr/search?q=${encodeURIComponent(siretValue)}&page=1&per_page=1`;

			fetch(apiUrl)
				.then(response => {
					if (!response.ok) {
						throw new Error('SIRET API error');
					}
					return response.json();
				})
				.then(data => {
					const hasResults = data && Array.isArray(data.results) && data.results.length > 0;

					if (hasResults) {
						showSiretValid();
					} else {
						showSiretError();
					}
				})
				.catch(() => {
					// On API error, consider SIRET invalid but do not block forever
					resetSiretUi();
					siretIsValid = false;
					siretChecking = false;
					updateSubmitLock();
				});
		}, 400);
	};

	// Handle SIRET input changes
	siretInput.addEventListener('input', () => {
		// Keep only digits and limit to 14 chars
		siretInput.value = siretInput.value.replace(/\D/g, '').slice(0, 14);

		const value = siretInput.value;

		// If field is empty
		if (value.length === 0) {
			resetSiretUi();
			siretIsValid = false;
			siretChecking = false;
			updateSubmitLock();
			return;
		}

		// If user typed between 1 and 13 digits, we know SIRET is not valid yet
		if (value.length < 14) {
			resetSiretUi();
			siretIsValid = false;
			siretChecking = false;
			// User is trying to be pro but SIRET is incomplete, so lock
			updateSubmitLock();
			return;
		}

		// When 14 digits are present, trigger API validation
		checkSiretWithApi(value);
	});

	// Handle company input changes
	companyInput.addEventListener('input', () => {
		// Anytime company changes, we recompute locking logic
		updateSubmitLock();
	});

	// Before submitting the form, enforce rules and set customer note
	registerForm.addEventListener('submit', event => {
		updateSubmitLock();

		// If button is disabled according to our rules, prevent submit
		if (submitButton.disabled) {
			event.preventDefault();
			return;
		}

		setCustomerTypeNote();
	});
});